import { useState, useCallback, useEffect } from 'react';

const useZoomPan = () => {
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [isPanning, setIsPanning] = useState(false);
  const [startPanPoint, setStartPanPoint] = useState({ x: 0, y: 0 });

  const handleZoom = useCallback((delta) => {
    setZoom(prevZoom => {
      const newZoom = prevZoom + delta * 0.1;
      return Math.min(Math.max(0.5, newZoom), 3);
    });
  }, []);

  const handlePanStart = useCallback((e) => {
    setIsPanning(true);
    setStartPanPoint({ x: e.clientX, y: e.clientY });
  }, []);

  const handlePan = useCallback((e) => {
    if (!isPanning) return;
    
    setPan(prevPan => ({
      x: prevPan.x + (e.clientX - startPanPoint.x) / zoom,
      y: prevPan.y + (e.clientY - startPanPoint.y) / zoom
    }));
    
    setStartPanPoint({ x: e.clientX, y: e.clientY });
  }, [isPanning, startPanPoint, zoom]);

  useEffect(() => {
    const handleMouseUp = () => setIsPanning(false);
    window.addEventListener('mouseup', handleMouseUp);
    return () => window.removeEventListener('mouseup', handleMouseUp);
  }, []);

  return { zoom, pan, handleZoom, handlePanStart, handlePan };
};

export default useZoomPan;